<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-subtitle>プランを選択してください</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select :items="plans" label="プラン" v-model="plan" outlined>
              <template slot="selection" slot-scope="data">
                <div class="plan-item">
                  <div class="plan-name">
                    {{ data.item.name }}
                  </div>
                  <div class="plan-desc" v-html="data.item.desc"></div>
                </div>
              </template>
              <template slot="item" slot-scope="data">
                <div class="plan-item">
                  <div class="plan-name">
                    {{ data.item.name }}
                  </div>
                  <div class="plan-desc" v-html="data.item.desc"></div>
                </div>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col>
            <v-btn color="primary" :disabled="isProcessing || !plan" @click="createCheckoutSession">
              <v-progress-circular
                v-if="isProcessing"
                indeterminate
                color="primary"
                :width="2"
                :size="20"
              ></v-progress-circular>
              {{ isProcessing ? null : '次へ' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<style scoped>
.plan-item {
  padding: 8px 0;
}
.plan-name {
  font-weight: bold;
}
.plan-desc {
  font-size: 0.8em;
  color: gray;
}
</style>

<script>
import { createCheckoutSession } from '@/services/functions'
import { createNamespacedHelpers } from 'vuex'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'
import { Plan, userCollection } from '@shared/collections/user.collection'

const userStore = createNamespacedHelpers('user')

export default {
  components: {
    SeaPlusNavIcon,
    AccumulateNavButton
  },
  data: () => ({
    plan: Plan.SUBSCRIPTION_30,
    plans: Plan.all().map((plan) => ({
      name: Plan.getName(plan),
      desc: Plan.getDesc(plan).replaceAll('\n', '<br/>'),
      value: plan
    })),
    isProcessing: false
  }),
  computed: {
    ...userStore.mapState(['userId', 'user'])
  },
  methods: {
    async createCheckoutSession() {
      this.isProcessing = true
      await userCollection.update(this.user.id, {
        plan: this.plan
      })
      const {
        data: { checkoutSession }
      } = await createCheckoutSession({
        plan: this.plan,
        successUrl: `${window.location.origin}/checkout/success`,
        cancelUrl: `${window.location.origin}/checkout?plan=${this.plan}`
      })
      this.isProcessing = false
      if (checkoutSession && checkoutSession.url) {
        window.location.href = checkoutSession.url
      }
    },
    checkStripeSubscriptionStatus() {
      if (this.user) {
        if (this.user.plan !== Plan.ONE_TIME_PURCHASE && this.user.stripeSubscriptionId === 'active') {
          this.$router.replace('/')
        }
      }
    }
  },
  watch: {
    user() {
      this.checkStripeSubscriptionStatus()
    }
  },
  mounted() {
    this.checkStripeSubscriptionStatus()
    this.plan = this.$route.query.plan || Plan.SUBSCRIPTION_30
  }
}
</script>
